import type { AppConfig } from '../../config/appConfig';

/** Free for commercial use, no API key, no SLA. */
export const DEFAULT_MAP_STYLE_URL = 'https://tiles.openfreemap.org/styles/positron';

export function resolveMapStyleUrl(config: Pick<AppConfig, 'mapStyleUrl'>): string {
  const configured = config.mapStyleUrl?.trim();
  return configured ? configured : DEFAULT_MAP_STYLE_URL;
}
